const AppConfig = {
	recentPlansHref: '',
	epiProductsApiHost: '',
	aemImageEnv: '',
	launchDarklyKey: '',
	searchServiceHost: '',
	apiPrefix: '',
	mlcApiPrefix: '',
	dynatraceScript: '',
	adobeScript: '',
	idp: {},
};

export default AppConfig;

export const updateConfig = (config: any) => {
	AppConfig.recentPlansHref = config.recentPlansHref;
	AppConfig.epiProductsApiHost = config.epiProductsApiHost;
	AppConfig.aemImageEnv = config.aemImageEnv;
	AppConfig.launchDarklyKey = config.launchDarklyKey;
	AppConfig.searchServiceHost = config.searchServiceHost;
	AppConfig.apiPrefix = config.apiPrefix;
	AppConfig.mlcApiPrefix = config.mlcApiPrefix;
	AppConfig.dynatraceScript = config.dynatraceScript;
	AppConfig.adobeScript = config.adobeScript;
	AppConfig.idp = config.idp;
};
